/*=========================================================================================
  File Name: moduleCountryMutations.js
  Description: Country Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
    state.countries.unshift(item)
  },
  SET_OpportunityStatuses(state, OpportunityStatusList) {
    
    try {
      // const parsedData = JSON.parse(OpportunityStatusList.data);
      state.OpportunityStatusList = OpportunityStatusList.Data;

    } catch (error) {
      console.error("Failed to parse countries data JSON:", error);
      state.OpportunityStatusList = [];
    }
  },
  UPDATE_Country(state, country) {
    
    const countryIndex = state.countries.findIndex((p) => p.ID == country.ID)
    Object.assign(state.countries[countryIndex], country)
  },

  Get_Country(state, country){
    try {
      
      const parsedData = JSON.parse(country.data);
      state.country = parsedData;
    } catch (error) {
      console.error("Failed to parse country data JSON:", error);
      state.countries = [];
    }
  },
  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.countries.findIndex((p) => p.ID == itemId)
      state.countries.splice(ItemIndex, 1)
  },
}
